import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/building': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M128 148V108C128 101.4 133.4 96 140 96H180C186.6 96 192 101.4 192 108V148C192 154.6 186.6 160 180 160H140C133.4 160 128 154.6 128 148zM268 160H308C314.6 160 320 154.6 320 148V108C320 101.4 314.6 96 308 96H268C261.4 96 256 101.4 256 108V148C256 154.6 261.4 160 268 160zM140 256H180C186.6 256 192 250.6 192 244V204C192 197.4 186.6 192 180 192H140C133.4 192 128 197.4 128 204V244C128 250.6 133.4 256 140 256zM268 256H308C314.6 256 320 250.6 320 244V204C320 197.4 314.6 192 308 192H268C261.4 192 256 197.4 256 204V244C256 250.6 261.4 256 268 256zM192 340V300C192 293.4 186.6 288 180 288H140C133.4 288 128 293.4 128 300V340C128 346.6 133.4 352 140 352H180C186.6 352 192 346.6 192 340zM268 352H308C314.6 352 320 346.6 320 340V300C320 293.4 314.6 288 308 288H268C261.4 288 256 293.4 256 300V340C256 346.6 261.4 352 268 352zM448 476V512H0V476C0 469.4 5.4 464 12 464H31.5V24C31.5 10.7 42.2 0 55.5 0H392.5C405.8 0 416.5 10.7 416.5 24V464H436C442.6 464 448 469.4 448 476zM79.5 463H192V396C192 389.4 197.4 384 204 384H244C250.6 384 256 389.4 256 396V463H368.5V49L80 48 79.5 463z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/building.js
// module id = 3JKz
// module chunks = 144